import {
  FormControl,
  Grid,
  Paper,
  TextField,
  Typography,
  withStyles,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { DialogoConfirmacaoAcao } from "features/shared/components/DialogoConfirmacaoAcao";
import React, { useEffect, useState } from "react";
import {
  filterGanhoPesoMemoize,
  mensagemBotao,
  mesesNull,
} from "../ganhoPesoUtils";
import GanhoPesoForm from "./ganhoPesoForm";
import GanhoPesoTabela from "./ganhoPesoTabela";
import { useTranslations } from "adapters/i18n";

export function GanhoPesoPage(props) {
  const { obterCurvasGanhoPeso, fazendaSelecionada, curvas, classes } = props;

  const [confirmacaoExclusaoAberto, setConfirmacaoExclusaoAberto] =
    useState(false);
  const [exibindo, setExibindo] = useState(false);
  const [adicionando, setAdicionando] = useState(false);
  const [filtro, setFiltro] = useState("");
  const [erroNome, setErroNome] = useState(false);
  const { t } = useTranslations();

  const [curva, setCurva] = useState({
    erroPeso: false,
    Selecionada: false,
    IdCurvaGanhoPeso: null,
    Nome: "",
    IdFazenda: fazendaSelecionada,
    ...mesesNull,
  });

  const [curvaSelecionada, setCurvaSelecionada] = useState({
    Selecionada: false,
    IdCurvaGanhoPeso: null,
    IdFazenda: fazendaSelecionada,
    Nome: "",
    ...mesesNull,
  });

  useEffect(() => {
    const carregarCurvas = async () => {
      await obterCurvasGanhoPeso(fazendaSelecionada);
    };
    carregarCurvas();
  }, [obterCurvasGanhoPeso, fazendaSelecionada]);

  const abreDialogExclusao = (curva) => {
    setConfirmacaoExclusaoAberto(true);
    setCurvaSelecionada(curva);
  };

  const fechaDialogExclusao = () => {
    setConfirmacaoExclusaoAberto(false);
  };

  const handleChangeNomeCurva = (event) => {
    const nome = event.target.value.toUpperCase();
    setCurva((prev) => ({ ...prev, Nome: nome }));
    setErroNome(curvas.some((c) => c.Nome.trim() === nome.trim()));
  };

  const handleChangeMes = (nomeMes, novoValor) => {
    if (novoValor > 5) {
      setCurva((prev) => ({ ...prev, erroPeso: true }));
    }
    if (novoValor < 0) {
      novoValor = 0;
    }
    const valorConvertido = Number(novoValor);
    setCurva((prev) => ({ ...prev, [nomeMes]: valorConvertido }));
  };

  const extraiMesesCurvaGanhoPeso = (curva) => {
    if (!curva) return [];
    const {
      Janeiro,
      Fevereiro,
      Marco,
      Abril,
      Maio,
      Junho,
      Julho,
      Agosto,
      Setembro,
      Outubro,
      Novembro,
      Dezembro,
    } = curva;
    return [
      Janeiro,
      Fevereiro,
      Marco,
      Abril,
      Maio,
      Junho,
      Julho,
      Agosto,
      Setembro,
      Outubro,
      Novembro,
      Dezembro,
    ];
  };

  const pesosNaoSaoNulos = () => {
    const camposMeses = extraiMesesCurvaGanhoPeso(curva);
    return camposMeses.every(
      (value) => value !== null && typeof value === "number"
    );
  };

  const pesosSaoValidos = () => {
    const camposMeses = extraiMesesCurvaGanhoPeso(curva);
    return camposMeses.some((value) => value > 0);
  };

  const pesosSaoMenoresQueValor = () => {
    const camposMeses = extraiMesesCurvaGanhoPeso(curva);
    return camposMeses.every((value) => {
      return value < 5;
    });
  };

  const _validaCamposPeso = () => {
    return [pesosNaoSaoNulos(), pesosSaoValidos(), pesosSaoMenoresQueValor()];
  };

  const habilitarBotao = () => {
    const [pesosNaoSaoNulos, pesosSaoValidos, pesosSaoMenoresQueValor] =
      _validaCamposPeso();

    if (
      curva.Nome !== "" &&
      !erroNome &&
      pesosNaoSaoNulos &&
      pesosSaoValidos &&
      pesosSaoMenoresQueValor
    ) {
      return false;
    }
    return true;
  };

  const mostrarMensagemBotao = () => {
    const [pesosNaoSaoNulos, pesosSaoValidos, pesosSaoMenoresQueValor] =
      _validaCamposPeso();
    if (pesosNaoSaoNulos === false && pesosSaoValidos === false) {
      return mensagemBotao.mesesNaoPreenchidos;
    } else if (pesosNaoSaoNulos === false && pesosSaoValidos === true) {
      return mensagemBotao.mesesNaoPreenchidos;
    } else if (pesosNaoSaoNulos === true && pesosSaoValidos === false) {
      return mensagemBotao.mesValorDiferenteZero;
    } else if (
      pesosNaoSaoNulos === true &&
      pesosSaoValidos === true &&
      pesosSaoMenoresQueValor === false
    ) {
      return mensagemBotao.mesesValorMaiorQueValor;
    } else {
      return "";
    }
  };

  const habilitarCurva = (acao) => {
    setAdicionando(acao);
    setCurva({
      Selecionada: false,
      Nome: "",
      IdFazenda: fazendaSelecionada,
      ...mesesNull,
    });
    setErroNome(false);
  };

  const adicionarCurva = async (curvaParam) => {
    if (curvaParam.IdCurvaGanhoPeso) {
      await props.atualizarCurva(curvaParam);
    } else {
      await props.criarCurva(curvaParam);
    }
    await obterCurvasGanhoPeso();
    setCurva({
      Selecionada: false,
      Nome: "",
      ...mesesNull,
    });
    setAdicionando(false);
  };

  const habilitarEdicao = (curvaParam) => {
    setAdicionando(true);
    setCurva(curvaParam);
  };

  const habilitarExibicao = (curvaParam) => {
    curvaParam.Selecionada = !curvaParam.Selecionada;
    setCurva(curvaParam);
    setExibindo(!exibindo);
  };

  const excluirCurva = async (idCurva) => {
    await props.deletarCurva(idCurva);
    await obterCurvasGanhoPeso();
    setCurva({
      Selecionada: false,
      Nome: "",
      ...mesesNull,
    });
    setAdicionando(false);
  };

  const ganhosDePesoFiltrados = filterGanhoPesoMemoize(curvas, filtro);

  return (
    <React.Fragment>
      <Paper square className={classes.root}>
        <Grid container className={classes.containerPage}>
          <Typography className={classes.titulo} gutterBottom>
            {t("weightGainCurve:page-title")}
          </Typography>

          <Grid
            container
            xs={12}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <FormControl
              className={classes.formContainer}
              disabled={adicionando}
            >
              <TextField
                id="inputFiltro"
                autoFocus
                label={t("weightGainCurve:search-curve")}
                style={{ width: 274 }}
                inputProps={{
                  className: {
                    fontsize: "14px",
                    fontcolor: "#757575",
                  },
                }}
                className={classes.inputFiltro}
                onChange={({ target }) => setFiltro(target.value)}
              />
            </FormControl>
            {adicionando ? (
              <Paper square className={classes.corpoAdicionar}>
                <GanhoPesoForm
                  id="formAdicionar"
                  classes={classes}
                  curva={curva}
                  erroNome={erroNome}
                  abreDialogExclusao={abreDialogExclusao}
                  adicionarCurva={adicionarCurva}
                  habilitarCurva={habilitarCurva}
                  handleChangeNomeCurva={handleChangeNomeCurva}
                  handleChangeMes={handleChangeMes}
                  habilitarBotao={habilitarBotao}
                  mensagemBotaoDesabilitado={mostrarMensagemBotao()}
                />
              </Paper>
            ) : (
              <Button
                id="botaoAdicionar"
                onClick={() => habilitarCurva(true)}
                variant="contained"
                color="primary"
                className={classes.botaoNovo}
              >
                {t("weightGainCurve:new-curve")}
              </Button>
            )}
          </Grid>
          <Grid container xs={12}>
            <GanhoPesoTabela
              id="ganhoDePesoTabela"
              ganhosDePesoFiltrados={ganhosDePesoFiltrados}
              habilitarEdicao={habilitarEdicao}
              adicionando={adicionando}
              habilitarExibicao={habilitarExibicao}
              curva={curva}
              exibindo={exibindo}
            />
          </Grid>
        </Grid>
      </Paper>
      <DialogoConfirmacaoAcao
        id={`dialogConfirmaExclusaoCurva`}
        tituloDialog={t("weightGainCurve:delete-curve-modal.title")}
        textoDialog={
          <span id="mensagemConfirmaExclusaoCurva">
            {t("weightGainCurve:delete-curve-modal.description")}
          </span>
        }
        dialogAberto={confirmacaoExclusaoAberto}
        cancelarAcaoDialog={fechaDialogExclusao}
        objetoSelecionado={curvaSelecionada.IdCurvaGanhoPeso}
        excluir={excluirCurva}
      />
    </React.Fragment>
  );
}

const styles = (theme) => {
  return {
    containerPage: {
      flexgrow: 1,
      height: "100%",
      backgroundColor: "#fff",
      width: "100%",
    },
    root: {
      width: "100%",
      height: "100%",
      overflowX: "auto",
      padding: "46px",
      zIndex: -1,
      bottom: 0,
      top: "17%",
      minHeight: "calc(100vh - 90px)",
    },
    botaoNovo: {
      borderRadius: "18px",
      float: "right",
      marginRight: 0,
      marginTop: 34,
      height: 35,
      fontSize: 14,
      boxShadow: "none!important",
    },
    corpoAdicionar: {
      width: "100%",
      marginTop: "19.5px",
      padding: "24px 32px",
      borderRadius: "16px",
    },
    titulo: {
      fontSize: "20px",
      fontWeight: "bold",
      color: "#444",
      marginTop: "40px",
      fontFamily: "Roboto",
    },
    formContainer: {
      marginTop: "20px",
    },
    inputFiltro: {
      width: "400px",
    },
  };
};

export default withStyles(styles)(GanhoPesoPage);
